const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/** Accepts "1990-05-12", "1990-05-12 00:00:00" or "05-12-1990". */
export function formatDate(value) {
  if (!value) return null;

  const raw = String(value).split(' ')[0];

  let year;
  let month;
  let day;

  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const us = raw.match(/^(\d{2})-(\d{2})-(\d{4})$/);

  if (iso) {
    year = Number(iso[1]);
    month = Number(iso[2]);
    day = Number(iso[3]);
  } else if (us) {
    month = Number(us[1]);
    day = Number(us[2]);
    year = Number(us[3]);
  } else {
    return raw;
  }

  if (!MONTHS[month - 1]) return raw;

  return MONTHS[month - 1] + ' ' + day + ', ' + year;
}

export function fullName(profile) {
  if (!profile) return '';
  const parts = [profile.first_name, profile.last_name].filter(Boolean);
  return parts.join(' ').trim();
}

/** Builds a multi-line address from the individual fields. */
export function addressLines(profile) {
  if (!profile) return [];

  const cityLine = [profile.city, profile.state].filter(Boolean).join(', ');
  const cityZip = [cityLine, profile.zip_code].filter(Boolean).join(' ');

  return [profile.address_line_1, profile.address_line_2, cityZip].filter(
    function (line) {
      return line && String(line).trim() !== '';
    }
  );
}

export function initials(profile) {
  const name = fullName(profile);
  if (!name) return '?';

  const parts = name.split(/\s+/);
  const first = parts[0] ? parts[0].charAt(0) : '';
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';

  return (first + last).toUpperCase() || '?';
}

export function formatNumber(value) {
  const number = Number(value || 0);
  return number.toLocaleString ? number.toLocaleString('en-US') : String(number);
}
